// Mobile 框架未支持配置化
export const MOBILE_WEEKLY_PAGE_CONFIG = {
  showUnconfiguredPage: true,
  unconfiguredComponentName: 'MobileWeekly'
};